import { ActionTree } from 'vuex';
import {AxiosError, AxiosResponse} from 'axios';
import {login, RootState} from './types';
import Vue from 'vue';
import {User} from 'firebase';

/* tslint:disable:no-console */

export const actions: ActionTree<RootState, RootState> = {

  async Login({commit}, body: login): Promise<any> {
    try {
      const response = await Vue.prototype.$auth.signInWithEmailAndPassword(body.email, body.password);
      return response;
    } catch (e) {
      console.log(e);
      throw new Error(e.message);
    }
  },

  async CreateUser({commit}, body: login): Promise<any> {
    try {
      const createUserResponse =
        await Vue.prototype.$auth.createUserWithEmailAndPassword(body.email, body.password);
      return createUserResponse;
    } catch (e) {
      console.log(e);
      throw new Error(e.message);
    }
  },

  async SignOut({commit}): Promise<any> {
    try {
      await Vue.prototype.$auth.signOut();
    } catch (e) {
      console.log(e);
    }
  },
};
